import { useEffect } from 'react'
import ReactGA from 'react-ga4'

const MEASUREMENT_ID = 'G-F8V3JXFCVF'

export function useAnalytics() {
  useEffect(() => {
    // Initialize Google Analytics
    ReactGA.initialize(MEASUREMENT_ID)
  }, [])

  const trackPageView = (path: string) => {
    ReactGA.send({ hitType: 'pageview', page: path })
  }

  return { trackPageView }
}
